<rt-attributes
  [attributes]="selected"
  [canCreate]="canCreate"
  [canPick]="true"
  [canRemove]="true"
  [createDisabled]="!canCreate"
  [dropdownPositions]="dropdownPositions"
  [hasTriggerWidth]="hasTriggerWidth"
  [listTpl]="listTpl"
  [selectFooterTemplate]="selectFooterTemplate"
  [selectHeaderTemplate]="selectHeaderTemplate"
  [suggestionsData]="suggestions"
  [tagsClickable]="false"
  [tagsHoverable]="false"
  [toggle]="toggleDropdown"
  [translationsContext]="'departments'"
  [markSelected]="markSelected"
  (query)="query.emit($event)"
  (save)="select.emit($any($event))"
  (delete)="remove.emit($any($event))"
/>
